import { urlConstants } from 'common/utils/constants';

import { secureApi } from '../api/Axios';

export const referInvestor = (payload: any) =>
  secureApi.post(urlConstants.referInvestor, payload);

export const getInvestorAllReferral = () =>
  secureApi.get(urlConstants.getInvestorAllReferral);

export const resendReferInviteToInvestor = (payload: any) =>
  secureApi.post(urlConstants.resendReferInviteToInvestor, payload);

export const getDealToVisit = () =>
  secureApi.get(`${urlConstants.getDealToVisit}`);

export const refereeInvestorVisitedDeal = () =>
  secureApi.post(urlConstants.refereeInvestorVisitedDeal);

export const checkReferralEmailRegistered = (email: string) =>
  secureApi.get(`${urlConstants.checkReferralEmailRegistered}?email=${email}`);
